import React from 'react';
import { Outlet } from 'react-router-dom';

// Renders the shared public layout wrapper for non-admin routes.
export function NewLayout() {
  return (
    <div className="new-layout">
      <Outlet />
    </div>
  );
}
